import styled from 'styled-components';

export const DrawerContainer = styled.div`
  position: relative;
  height: 100%;
  z-index: 40;
  width: ${({ open }) => (open ? '25%' : '0px')};
  transition: width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;

  @media (max-width: 640px) {
    position: absolute;
    width: 100%;
    height: auto;
    bottom: 0;
  }

  &.has-error {
    .drawer-button span {
      color: #f44336;
    }
  }

  .drawer-select-container {
    min-height: 80px;
    padding: 0 5px;
  }

  .PropertyItemsContainer,
  .drawer-select-container {
    visibility: ${({ hide }) => (hide ? 'hidden' : 'visible')};
  }
`;

export const Spacing = styled.span`
  display: block;
  margin: 40px 0px;

  @media (max-width: 640px) {
    margin: 30px 0;
  }
`;

export const NoResultsContainer = styled.div`
  padding: 20px 30px;
  overflow-y: auto;

  .no-result-suggestions {
    margin-left: 20px;
  }

  .description-spacing {
    margin-bottom: 30px;
  }
`;

export const PreferredPropertiesContainer = styled.div`
  padding: 0 1rem;
`;

export const RelevantPropertiesContainer = styled.div`
  padding: 0rem 1rem 1rem 1rem;
  background-color: #ffffff;
`;

export const SpinnerContainer = styled.div`
  text-align: center;
  padding: 2rem;
`;
